import React, { useState } from "react";

// ASSETS
import dsuAppFiipregatit from "assets/img/dsuAppFiipregatit.png";
import AppQrCode from "assets/svg/AppQrCode.svg";
import DsuAppScreen from "assets/img/DsuAppScreen.png";
import FiiPregatitScreen from "assets/img/FiiPregatitScreen.png";
import { ReactComponent as GooglePlay } from "assets/svg/GooglePlay.svg";
import { ReactComponent as AppStore } from "assets/svg/AppStore.svg";

// STYLES
import {
  SectionWrapper,
  ItemWrapper,
  LeftContent,
  LeftSideContainer,
  MainIllustration,
  MiddleSideContainer,
  QrContainer,
  QrRow,
  RightContent,
  RightSideWrapper,
  TitleRow,
  ButtonContainer,
  MobileItemWrapper,
  MobilePhonesIllustration,
  ContentContainer,
  WhiteContentContainer,
  MobileTitleRow,
  MobileBody,
  MobileButtonContainer,
  MobileSectionWrapper,
  IconsContainer,
} from "./ProductsSectionsStyled";

// LIBRARIES
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";

// MISC
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { ButtonType } from "components/Atoms/ButtonAtom/ButtonAtomModel";

// REDUX

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";
import { COLORS } from "constants/variables";
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";

const ProductsSections = () => {
  // PROPERTIES

  // LIBRARY CONSTANTS
  const { t } = useTranslation();

  // STATE CONSTANTS
  const isMobile = useMediaQuery({ maxWidth: 1227 });

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS
  const navigateToFiiPregatit = () => {
    window.open("https://fiipregatit.ro/", "_blank");
  };

  const navigateToStore = () => {
    const userAgent = navigator.userAgent || navigator.vendor;

    // iOS detection
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      window.open("https://apps.apple.com/ro/app/dsu/id1663813906", "_blank");
    }
    // Android detection
    else if (/android/i.test(userAgent)) {
      window.open(
        "https://play.google.com/store/apps/details?id=com.orson.dsu&hl=ro&pli=1",
        "_blank"
      );
    } else {
      // Optionally handle other platforms or provide a default action
      alert(
        "Your device is not supported for direct download. Please visit the App Store or Google Play Store."
      );
    }
  };

  if (isMobile) {
    return (
      <MobileSectionWrapper>
        <MobileItemWrapper>
          <MobilePhonesIllustration src={FiiPregatitScreen} alt="" />
          <ContentContainer>
            <MobileTitleRow>
              <CustomText
                text={t("view.homePage.carousel.item1.title")}
                type={TextType.H2}
                color={COLORS.Background}
              />

              <CustomText
                text={t("view.homePage.carousel.item1.titleColored")}
                type={TextType.H2}
                color={COLORS.Red}
              />
            </MobileTitleRow>
            <MobileBody>
              <CustomText
                text={t("view.homePage.carousel.item1.body")}
                type={TextType.P1}
                color={COLORS.Background}
              />
            </MobileBody>
            <MobileButtonContainer onClick={navigateToFiiPregatit}>
              <ButtonAtom
                text={t("view.homePage.carousel.item1.buttonMessage")}
                type={ButtonType.ArrowDownDefault}
                rightIcon={true}
              />
            </MobileButtonContainer>
          </ContentContainer>
        </MobileItemWrapper>

        <MobileItemWrapper>
          <MobilePhonesIllustration src={DsuAppScreen} alt="" />
          <WhiteContentContainer>
            <MobileTitleRow>
              <CustomText
                text={t("view.homePage.carousel.item2.title")}
                type={TextType.H2}
                color={COLORS.RaisinBlack}
              />

              <CustomText
                text={t("view.homePage.carousel.item2.titleColored")}
                type={TextType.H2}
                color={COLORS.Red}
              />
            </MobileTitleRow>
            <MobileBody>
              <CustomText
                text={t("view.homePage.carousel.item2.body")}
                type={TextType.P1}
                color={COLORS.RaisinBlack}
              />
            </MobileBody>
            <IconsContainer>
              <GooglePlay />
              <AppStore />
            </IconsContainer>
            <MobileButtonContainer onClick={navigateToStore}>
              <ButtonAtom
                text={t("view.homePage.carousel.item2.buttonMessage")}
                type={ButtonType.ArrowDownDefault}
                rightIcon={true}
              />
            </MobileButtonContainer>
          </WhiteContentContainer>
        </MobileItemWrapper>
      </MobileSectionWrapper>
    );
  } else {
    return (
      <SectionWrapper>
        <ItemWrapper>
          <LeftSideContainer>
            <LeftContent>
              <TitleRow>
                <CustomText
                  text={t("view.homePage.carousel.item2.title")}
                  type={TextType.H2}
                  color={COLORS.Background}
                />
                <CustomText text={" "} type={TextType.H2} />
                <CustomText
                  text={t("view.homePage.carousel.item2.titleColored")}
                  type={TextType.H2}
                  color={COLORS.Red}
                />
              </TitleRow>
              <CustomText
                text={t("view.homePage.carousel.item2.body")}
                type={TextType.P1}
                color={COLORS.Background}
              />
              <QrRow>
                <CustomText
                  text={t("view.homePage.carousel.item2.buttonMessageDesktop")}
                  type={TextType.H4bold}
                  color={COLORS.Background}
                />
                <QrContainer src={AppQrCode} alt="Qr" />
              </QrRow>
              <IconsContainer>
                <GooglePlay />
                <AppStore />
              </IconsContainer>
            </LeftContent>
          </LeftSideContainer>
          <MiddleSideContainer>
            <MainIllustration src={dsuAppFiipregatit} alt="" />
          </MiddleSideContainer>
          <RightSideWrapper>
            <RightContent>
              <TitleRow>
                <CustomText
                  text={t("view.homePage.carousel.item1.title")}
                  type={TextType.H2}
                  color={COLORS.RaisinBlack}
                />
                <CustomText text={" "} type={TextType.H2} />
                <CustomText
                  text={t("view.homePage.carousel.item1.titleColored")}
                  type={TextType.H2}
                  color={COLORS.Red}
                />
              </TitleRow>
              <CustomText
                text={t("view.homePage.carousel.item1.body")}
                type={TextType.P1}
                color={COLORS.RaisinBlack}
              />
              <IconsContainer></IconsContainer>
              <ButtonContainer>
                <ButtonAtom
                  type={ButtonType.ArrowButton}
                  onClick={navigateToFiiPregatit}
                  text={t("view.homePage.carousel.item1.buttonMessage")}
                  rightIcon={true}
                />
              </ButtonContainer>
            </RightContent>
          </RightSideWrapper>
        </ItemWrapper>
      </SectionWrapper>
    );
  }
};

export default ProductsSections;
